import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { productsAPI, benefitsAPI, contactsAPI, galleryAPI } from '../../services/api';
import { Package, Heart, Mail, Image } from 'lucide-react';

const Dashboard = () => {
  const [stats, setStats] = useState({
    products: 0,
    benefits: 0,
    contacts: 0,
    gallery: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [products, contacts] = await Promise.all([
        productsAPI.getAll(false),
        contactsAPI.getAll()
      ]);

      setStats({
        products: products.data.length,
        contacts: contacts.data.length,
        newMessages: contacts.data.filter(c => c.status === 'new').length
      });
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    {
      title: 'Products',
      value: stats.products,
      icon: Package,
      color: 'bg-amber-500'
    },
    {
      title: 'Total Messages',
      value: stats.contacts,
      icon: Mail,
      color: 'bg-blue-500'
    },
    {
      title: 'New Messages',
      value: stats.newMessages,
      icon: Mail,
      color: 'bg-green-500'
    }
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading dashboard...</div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-600 mt-2">Welcome to your admin panel</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  {stat.title}
                </CardTitle>
                <div className={`w-10 h-10 ${stat.color} rounded-lg flex items-center justify-center`}>
                  <Icon className="text-white" size={20} />
                </div>
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-gray-900">
                  {stat.value}
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Quick Actions</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <a
              href="/admin/products"
              className="p-8 border-2 border-gray-200 rounded-lg hover:border-amber-500 hover:bg-amber-50 transition-all text-center group"
            >
              <Package className="mx-auto mb-3 text-amber-600 group-hover:scale-110 transition-transform" size={40} />
              <div className="font-semibold text-lg">Manage Products</div>
              <div className="text-sm text-gray-600 mt-1">Add, edit, or remove sauna products</div>
            </a>
            <a
              href="/admin/contacts"
              className="p-8 border-2 border-gray-200 rounded-lg hover:border-amber-500 hover:bg-amber-50 transition-all text-center group"
            >
              <Mail className="mx-auto mb-3 text-amber-600 group-hover:scale-110 transition-transform" size={40} />
              <div className="font-semibold text-lg">View Messages</div>
              <div className="text-sm text-gray-600 mt-1">Manage customer inquiries</div>
            </a>
            <a
              href="/admin/company"
              className="p-8 border-2 border-gray-200 rounded-lg hover:border-amber-500 hover:bg-amber-50 transition-all text-center group"
            >
              <Package className="mx-auto mb-3 text-amber-600 group-hover:scale-110 transition-transform" size={40} />
              <div className="font-semibold text-lg">Company Info</div>
              <div className="text-sm text-gray-600 mt-1">Update business details</div>
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Dashboard;